import BasfiFederationConfig from '../dto/basfi/FederationConfig';
import Error from '../model/Error';
import axios from 'axios';

export default class BasfiFederationConfigRepository {
    static find(federationId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/federations/${federationId}/basfi/config`)
                .then((response) => resolve(BasfiFederationConfig.fromData(response.data.data)))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static acceptTermsOfUse(federationId, version) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/federations/${federationId}/basfi/config`, {
                    acceptTermsOfUse: true,
                    version,
                })
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
